module.exports = __webpack_public_path__ + "img/Mirage.f58ade95.jpg";